const addressFunc = {
  fullNameAddress (addr) {
    let adStr = ''

    adStr += `ул. ${addr.street}`
    if (addr.house
    ) {
      adStr += ` д. ${addr.house}`
    }
    adStr += addr.entrance ? `, под. ${addr.entrance}` : ''
    adStr += addr.floor ? ', эт. ' + addr.floor : ''
    adStr += addr.apartment ? ', кв. ' + addr.apartment : ''
    adStr += addr.office ? ', офис. ' + addr.office : ''
    return adStr
  }
}

export default addressFunc



// WEBPACK FOOTER //
// ./src/helpers/formatAddress.js